import { colorsClassesMap as deprecatedColorsMap } from '@cian/ui-kit-design-tokens/colors/deprecated';
import { colorsClassesMap } from '@cian/ui-kit-design-tokens/colors';
export function colorToValue(color) {
  if (deprecatedColorsMap[color]) {
    return "var(--".concat(color, ")");
  }
  if (colorsClassesMap[color]) {
    return "var(--".concat(color, ")");
  }
  return color;
}